import { ArrowRight, HelpCircle } from 'lucide-react';
import { mainDomainHomeUrl, useWorkspaceStore } from '@/store/workspaceStore';

/**
 * Phase 12.1 — shown when subdomain {slug} doesn't map to any workspace
 * (typo, deleted, never registered). Redirects to main site.
 */
export default function WorkspaceNotFoundScreen() {
  const error = useWorkspaceStore((s) => s.error);
  const slug = error?.slug ?? '';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-surface-950 px-6">
      <div className="max-w-md text-center space-y-5">
        <div className="mx-auto h-14 w-14 rounded-full bg-surface-800 flex items-center justify-center">
          <HelpCircle className="text-surface-400" size={26} />
        </div>
        <h1 className="text-xl font-semibold text-surface-50">
          Workspace «{slug}» не существует
        </h1>
        <p className="text-sm text-surface-400">
          Проверьте адрес или перейдите на основной сайт.
        </p>
        <a
          href={mainDomainHomeUrl()}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-brand-500 hover:bg-brand-600 text-white text-sm font-medium transition-colors"
        >
          На основной сайт <ArrowRight size={16} />
        </a>
      </div>
    </div>
  );
}
